import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-12 col-lg-8 offset-lg-2 text-start" }
const _hoisted_3 = { class: "row border p-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-4 text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mt-4 fw-normal" }, "Documentación requerida")
], -1)
const _hoisted_5 = { class: "col-12 alert-info p-2 rounded-3 text-center mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Antes de continuar lea la siguiente información", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "col-12 alert-warning p-4"
}
const _hoisted_10 = { class: "col-12 mb-4" }
const _hoisted_11 = { class: "col-12 col-lg-6 offset-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheAttachedImages = _resolveComponent("TheAttachedImages")!
  const _component_FormDigitalSignature = _resolveComponent("FormDigitalSignature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: _ctx.deslindePdf,
                  target: "_blank",
                  class: "button_class m-auto btn-sm"
                }, " Deslinde de responsabilidad ", 8, _hoisted_8)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t(_ctx.deslindePdf)), 1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (
              typeof _ctx.state.navigation.actividad?.requiereCedula ===
                'undefined' ||
              _ctx.state.navigation.actividad?.requiereCedula === true 
            )
            ? (_openBlock(), _createBlock(_component_TheAttachedImages, {
                key: 0,
                title: "formularios.adjunto.licenciaConducir",
                modelValue: _ctx.formulario.imagenLicence,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formulario.imagenLicence) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_FormDigitalSignature, {
            modelValue: _ctx.formulario.imagenFirma,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formulario.imagenFirma) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}